import type { PurchaseChainOption } from 'src/utils/purchaseChains';

/**
 * How the network step is presented (multichain spec §4.3: "при одной доступной — без выбора,
 * бейдж сети").
 *
 * - `none` — nothing is payable here; the modal explains why instead of rendering a picker.
 * - `badge` — exactly one network: a statement of fact, not a choice. Showing a one-item list
 *   would ask the buyer to decide something already decided, and this is the shape the app is in
 *   wherever only one chain is enabled.
 * - `list` — a real choice between networks.
 *
 * Extracted from the component so the rule is testable on its own, like `showsAccountTabs`.
 */
export type NetworkSelectorMode = 'none' | 'badge' | 'list';

export const networkSelectorMode = (options: PurchaseChainOption[]): NetworkSelectorMode => {
  if (options.length === 0) {
    return 'none';
  }

  return options.length === 1 ? 'badge' : 'list';
};
